import React, { Component } from "react";
import LevelPage from "./LevelPage.js";
import LevelPageMobile from "./LevelPageMobile.js";

import { isMobile } from 'react-device-detect';

export class LevelPageResponsive extends Component {
 
 render() {
        return isMobile ? <LevelPageMobile /> : <LevelPage />
    }

}

export default LevelPageResponsive;
